// Single source of truth for the four resume-processing statuses used across
// the Upload Tracker listing, the JD detail tabs, header count chips, and
// candidate status pills. Colors come from the StatusBadge.jsx palette.
export const STATUS_META = [
  { key: 'STARTED', label: 'Started', color: '#5A6474', bg: '#F3F4F6' },
  { key: 'COMPLETED', label: 'Completed', color: '#0D9668', bg: '#ECFDF5' },
  { key: 'FAILED', label: 'Failed', color: '#DC2626', bg: '#FEF2F2' },
  { key: 'DUPLICATE', label: 'Duplicate', color: '#B45309', bg: '#FFFBEB' },
];

// Convenience map: status key -> text color (used for count cells).
export const STATUS_COLORS = STATUS_META.reduce((acc, s) => {
  acc[s.key] = s.color;
  return acc;
}, {});
